import React, {
  forwardRef
} from "react";
import { cx } from "@linaria/core";
import { Root, Input, Thumb, Track } from "./SwitchBase.styles";
const SwitchBase = forwardRef((props, ref) => {
  const { classes, className, id, color, ...rest } = props;
  return /* @__PURE__ */ React.createElement(Root, {
    "data-testid": "switch",
    className: cx(className, classes?.root),
    htmlFor: id,
    color
  }, /* @__PURE__ */ React.createElement(Input, {
    ...rest,
    "data-testid": "switch-input",
    id,
    type: "checkbox",
    ref
  }), /* @__PURE__ */ React.createElement(Track, {
    "data-testid": "switch-track",
    className: cx("switch__track", classes?.track)
  }, /* @__PURE__ */ React.createElement(Thumb, {
    "data-testid": "switch-thumb",
    className: cx("switch__thumb", classes?.thumb)
  })));
});
export default SwitchBase;
